// extracted by mini-css-extract-plugin
module.exports = {"labelWrapper":"style_labelWrapper__QC1sB"};